import {

    PREVIEW_INITIAL_PHASE,
    PREVIEW_PARAMS_CLEAR,
    PREVIEW_UPDATE_COMPANY,
    POPULATE_NEXT_PREV,
    PREVIEW_TABLE_URL_CHANGE,
    CHANGE_COLUMN_WIDTHS,
    PREVIEW_TABLE_COUNT_CHANGE,
    PREVIEW_INACTIVE_ENTITIES_COUNT

} from './PreviewCompany.actions';

import {
    USER_INFO_SUCCESS
} from './../Main/Main.reducers';


function previewCompany(state = null, action) {

    switch (action.type) {

        case USER_INFO_SUCCESS :
            if (action.payload.preferences) {
                if (action.payload.preferences.previewCompany) {
                    let urlData = Object.assign({}, state.urlParams, action.payload.preferences.previewCompany);
                    return Object.assign(
                        {}, state, {
                            urlParams: urlData
                        }
                    );
                }
            }
            return state;

        case PREVIEW_INITIAL_PHASE:
            return Object.assign(
                {}, state, {
                    stage: 'initial',
                    companyData: null,
                    nextCompany:     null,
                    previousCompany: null,
                    currentCompany: null,
                    articleCount: null
                }
            );

        case PREVIEW_PARAMS_CLEAR:
            return Object.assign(
                {}, state, {
                    urlParams: action.payload
                }
            );

        case PREVIEW_UPDATE_COMPANY:

        case POPULATE_NEXT_PREV:
            return Object.assign(
                {}, state, {
                    stage:           'companyLoaded',
                    nextCompany:     action.payload.next,
                    previousCompany: action.payload.previous,
                    currentCompany:  action.payload.current
                }
            );

        case PREVIEW_TABLE_COUNT_CHANGE:
            return Object.assign(
                {}, state, {
                    stage:         'companyLoaded',
                    articleCount: action.payload.count,
                    filterCount: action.payload.filterCount
                }
            );

        case PREVIEW_TABLE_URL_CHANGE:
        {
            return Object.assign(
                {}, state, {
                    urlParams: action.payload
                }
            );
        }

        case CHANGE_COLUMN_WIDTHS: {
            return Object.assign(
                {}, state, {
                    columnWidths: action.payload
                }
            );
        }

        case PREVIEW_INACTIVE_ENTITIES_COUNT:
        {
            return Object.assign(
                {}, state, {
                    previewEntitiesCount: action.payload
                }
            );
        }

        default:
            return state;

    }

}

export default previewCompany;


// WEBPACK FOOTER //
// ./src/scripts/pages/PreviewCompany/PreviewCompany.reducers.js